"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _get = _interopRequireDefault(require("lodash/get"));

var FacebookTimelineDataSource =
/*#__PURE__*/
function () {
  function FacebookTimelineDataSource() {
    (0, _classCallCheck2["default"])(this, FacebookTimelineDataSource);
  }

  (0, _createClass2["default"])(FacebookTimelineDataSource, null, [{
    key: "getName",
    value: function getName() {
      return 'Facebook Timeline';
    }
  }, {
    key: "getItemId",
    value: function getItemId(item) {
      return item.id;
    }
  }, {
    key: "parseFacebookDate",
    value: function parseFacebookDate(date) {
      if (date) {
        var a = date.split(/[^0-9]/);

        if (a.length >= 5) {
          var d = new Date(a[0], a[1] - 1, a[2], a[3], a[4], a[5]);
          return d;
        }
      }

      return date;
    }
  }, {
    key: "urlify",
    value: function urlify(text) {
      var urlRegex = /(https?:\/\/[^\s]+)/g;
      return text.replace(urlRegex, function (url) {
        return '<a target="_blank" href="' + url + '">' + url + '</a>';
      });
    }
  }, {
    key: "mapResult",
    value: function mapResult(result) {
      if (result) {
        result = result.data;
      }

      var mappedResult = result.map(function (item, index) {
        var attachment = item.attachments && item.attachments.data[0] && item.attachments.data[0].media && item.attachments.data[0].media.image;
        var title = FacebookTimelineDataSource.urlify(item.message || item.description || item.name || '');
        return (0, _objectSpread2["default"])({
          title: title,
          description: title,
          subtitle: '',
          media: {
            value: attachment && attachment.src || item.full_picture,
            width: attachment && attachment.width,
            height: attachment && attachment.height,
            noCdn: true
          },
          id: index,
          date: item.created_time && new Date(FacebookTimelineDataSource.parseFacebookDate(item.created_time)).toLocaleDateString(),
          likeCount: (0, _get["default"])(item, 'likes.summary.total_count')
        }, item);
      });
      return mappedResult.splice(0, 8);
    }
  }, {
    key: "getDataPromise",
    value: function getDataPromise(value, requestBody) {
      var item = [{
        id: 'eb635e32-2082-4a8a-b7fe-423a163d8431',
        value: value
      }];
      requestBody.item = item;
      return requestBody;
    }
  }]);
  return FacebookTimelineDataSource;
}();

FacebookTimelineDataSource.getRequestName = function () {
  return 'FacebookListPostsApi';
};

var _default = FacebookTimelineDataSource;
exports["default"] = _default;